import request from "@/utils/request";
const config = require("@/../config/config.json");

export async function svc_getBrandOutletCount() {
	return request(`${config.apiUrl}brands/get_outlet_stats`, {
		method: "GET",
	});
}
